// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// breakpoint
	const breakpoint = window.matchMedia('screen and (min-width: 960px)');

	// scroll volume
	function getScrolled() {
		return (window.pageYOffset !== undefined)
			? window.pageYOffset
			: document.documentElement.scrollTop;
	}



	// variable
	// --------------------------------------------------------------- //

	// scroll
	let scrollTop = window.pageYOffset;

	// url
	let url = location.href;



	// Dropdown for mobile
	// --------------------------------------------------------------- //

	const menuBtn   = document.getElementById('js-mobile-menu');
	const latestBtn = document.getElementById('js-latest-button');

	const navContainer = document.querySelector('.site-navigation-container');
	const navLatest    = document.querySelector('.site-navigation-latest');

	function updateBodyState() {
		if (
			navContainer?.classList.contains('is-open') ||
			navLatest?.classList.contains('is-open')
		) {
			document.body.classList.add('is-menu-open');
		} else {
			document.body.classList.remove('is-menu-open');
		}
	}

	menuBtn?.addEventListener('click', () => {
		navContainer?.classList.toggle('is-open');
		navLatest?.classList.remove('is-open');
		updateBodyState();
	});

	latestBtn?.addEventListener('click', () => {
		navLatest?.classList.toggle('is-open');
		navContainer?.classList.remove('is-open');
		updateBodyState();
	});



	// Pagetop
	// --------------------------------------------------------------- //

	const pagetop = document.querySelector('.page-top');

	pagetop?.addEventListener('click', () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	});



	// Fade Up
	// --------------------------------------------------------------- //

	const fadeUpItems = document.querySelectorAll('.js-fade-up');

	const fadeUpObserver = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add('is-show');
			}
		});
	}, {
		rootMargin: '0px 0px -10% 0px',
		threshold: 0
	});

	fadeUpItems.forEach((item) => {
		fadeUpObserver.observe(item);
	});





	// Main Swiper
	// --------------------------------------------------------------- //

	// const mainVisual = document.querySelector('.js-main-slider');

	// if (mainVisual) {
	// 	new Swiper(mainVisual, {
	// 		slidesPerView: 1,
	// 		loop: true,
	// 		speed: 1500,

	// 		autoplay: {
	// 			delay: 3000,
	// 		},

	// 		navigation: {
	// 			nextEl: '.swiper-button-next',
	// 			prevEl: '.swiper-button-prev',
	// 		},
	// 	});
	// }



	// News Slider
	// --------------------------------------------------------------- //

	const newsSliderElement = document.querySelector('.js-news-slider');

	if (newsSliderElement) {

		new Swiper(newsSliderElement, {
			slidesPerView: 1.2,
			spaceBetween: 20,
			loop: true,
			centeredSlides: true,

			navigation: {
				nextEl: '.news-slider-next',
				prevEl: '.news-slider-prev',
			},

			breakpoints: {
				960: {
					slidesPerView: 3,
					spaceBetween: 32,
				},
			},
		});

	}



	// Character Slider
	// --------------------------------------------------------------- //

	const characterSliderElement = document.querySelector('.js-character-slider');
	const characterMoreButton = document.querySelector('.front-character-btn .js-popup-open');

	if (characterSliderElement) {

		function updateCharacterIndex(swiper) {

			if (!characterMoreButton) {
				return;
			}

			// 現在のactiveスライド
			const activeSlide = swiper.slides[swiper.activeIndex];

			if (!activeSlide) {
				return;
			}

			// activeスライド内のdata-indexを持つボタン
			const activeButton = activeSlide.querySelector('.js-popup-open[data-index]');

			if (!activeButton) {
				return;
			}

			// 「もっと見る」にdata-indexをコピー
			characterMoreButton.dataset.index = activeButton.dataset.index;

		}

		new Swiper(characterSliderElement, {
			slidesPerView: 3,
			spaceBetween: 20,
			loop: true,
			centeredSlides: true,

			navigation: {
				nextEl: '.character-slider-next',
				prevEl: '.character-slider-prev',
			},

			breakpoints: {
				960: {
					slidesPerView: 3,
					spaceBetween: 20,
				},
			},

			on: {

				init(swiper) {
					updateCharacterIndex(swiper);
				},

				slideChange(swiper) {
					updateCharacterIndex(swiper);
				},

			},
		});

	}



	// Movie Slider
	// --------------------------------------------------------------- //

	const movieSliderElement = document.querySelector('.js-movie-slider');

	if (movieSliderElement) {

		new Swiper(movieSliderElement, {
			slidesPerView: 2.4,
			spaceBetween: 12,
			loop: true,
			speed: 6000,
			allowTouchMove: false,

			autoplay: {
				delay: 0,
				disableOnInteraction: false,
			},

			breakpoints: {
				960: {
					slidesPerView: 4,
					spaceBetween: 20,
				},
			},
		});

	}



	// Movie Popup
	// --------------------------------------------------------------- //

	const modal = document.querySelector('.js-movie-modal');

	if (modal) {

		const video = modal.querySelector('.js-movie');
		const openButtons = document.querySelectorAll('.js-movie-open');
		const closeButtons = modal.querySelectorAll('.js-movie-close');

		if (video) {

			openButtons.forEach(button => {

				button.addEventListener('click', () => {

					const videoUrl = button.dataset.video;

					if (!videoUrl) {
						return;
					}

					video.src = videoUrl;

					document.body.classList.add('is-modal-open');

					video.muted = true;

					video.play();

				});

			});


			closeButtons.forEach(button => {

				button.addEventListener('click', () => {

					document.body.classList.remove('is-modal-open');

					video.pause();
					video.currentTime = 0;
					video.removeAttribute('src');
					video.load();

				});

			});

		}

	}


	// Fixed banner
	// --------------------------------------------------------------- //
	const fixedBanner = document.querySelector('.fixed-banner');
	const footer = document.querySelector('footer');

	if (fixedBanner && footer) {
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					fixedBanner.classList.add('is-hidden');
				} else {
					fixedBanner.classList.remove('is-hidden');
				}
			});
		}, {
			threshold: 0
		});

		observer.observe(footer);
	}



	// Fancybox
	// --------------------------------------------------------------- //

	const popupButtons = document.querySelectorAll('.js-popup-open');
	const popupSliderElement = document.querySelector('.js-popup-slider');

	if (
		popupButtons.length &&
		popupSliderElement &&
		window.jQuery &&
		jQuery.fancybox
	) {

		let popupSwiper = null;

		jQuery(document).on('click', '.js-popup-open', function (e) {

			e.preventDefault();

			const index = Number(this.dataset.index);

			if (Number.isNaN(index)) {
				return;
			}

			jQuery.fancybox.open(
				{
					src: '#slider-popup',
					type: 'inline'
				},
				{
					touch: false,

					afterShow: function () {

						const slider = document.querySelector('.js-popup-slider');

						if (!slider) {
							return;
						}

						if (!popupSwiper) {

							popupSwiper = new Swiper(slider, {
								slidesPerView: 1,
								loop: true,

								navigation: {
									nextEl: '.popup-slider-next',
									prevEl: '.popup-slider-prev',
								},
							});

						}

						popupSwiper.update();
						popupSwiper.slideToLoop(index, 0);

					}
				}
			);

		});

	}



	// Story
	// --------------------------------------------------------------- //
	const storyContents = document.querySelector('.story-contents');
	if (storyContents) {
		const imgPath = storyContents.dataset.imgPath;
		const stories = {
			1: {
				number: 1,
				title: '新入社員がやってきた',
				image: `${imgPath}/main-visual-pc.jpg`,
				imageAlt: '第1話 新入社員がやってきた',
				youtube: 'https://www.youtube.com/watch?v=XXXXXXXXXXX',
				description: '第1話の説明テキストがここに入ります。'
			},

			2: {
				number: 2,
				title: 'はじめての大仕事',
				image: `${imgPath}/main-visual-pc.jpg`,
				imageAlt: '第2話 はじめての大仕事',
				youtube: 'https://www.youtube.com/watch?v=YYYYYYYYYYY',
				description: '第2話の説明テキストがここに入ります。'
			},

			3: {
				number: 3,
				title: 'タイトルが入ります',
				image: `${imgPath}/main-visual-pc.jpg`,
				imageAlt: '第3話の画像',
				youtube: 'https://www.youtube.com/watch?v=ZZZZZZZZZZZ',
				description: '第3話の説明テキストがここに入ります。'
			}

		};
		const storyButtons = document.querySelectorAll('.story-nav__button');
		const storyNumber = document.querySelector('.js-story-number');
		const storyTitle = document.querySelector('.js-story-title');
		const storyImage = document.querySelector('.js-story-image');
		const storyYoutube = document.querySelector('.js-story-youtube');
		const storyDescription = document.querySelector('.js-story-description');
		function showStory(storyId) {
			const story = stories[storyId];
			if (!story) {
				console.error(`第${storyId}話の情報がありません`);
				return;
			}
			if (storyNumber) {
				storyNumber.textContent = `第${story.number}話`;
			}
			if (storyTitle) {
				storyTitle.textContent = `「${story.title}」`;
			}
			if (storyImage) {
				storyImage.src = story.image;
				storyImage.alt = story.imageAlt;
			}
			if (storyYoutube) {
				storyYoutube.href = story.youtube;
			}
			if (storyDescription) {
				storyDescription.textContent = story.description;
			}
		}

		storyButtons.forEach(button => {
			button.addEventListener('click', () => {
				const storyId = button.dataset.storyId;
				storyButtons.forEach(item => {
					item.classList.remove('is-active');
				});
				button.classList.add('is-active');
				showStory(storyId);
			});
		});
		showStory(1);
	}

	// 記事のもっと見るボタン
	// --------------------------------------------------------------- //
	const moreButton = document.querySelector('.js-more-button');
	const postList = document.querySelector('.js-post-list');

	if (moreButton && postList) {

		moreButton.addEventListener('click', async () => {

			const currentPage = Number(moreButton.dataset.page);
			const maxPage = Number(moreButton.dataset.max);
			const ajaxUrl = moreButton.dataset.ajaxUrl;
			const nextPage = currentPage + 1;

			const formData = new FormData();

			formData.append('action', 'load_more_posts');
			formData.append('page', nextPage);

			moreButton.disabled = true;

			try {

				const response = await fetch(ajaxUrl, {
					method: 'POST',
					body: formData,
				});

				const html = await response.text();

				postList.insertAdjacentHTML('beforeend', html);

				moreButton.dataset.page = nextPage;

				if (nextPage >= maxPage) {
					moreButton.remove();
				} else {
					moreButton.disabled = false;
				}

			} catch (error) {

				console.error(error);
				moreButton.disabled = false;

			}
		});
	}
});